import React from 'react';
import classnames from 'classnames';
import styles from './styles.styl';

const Radiobutton = (props) => {
  const labelClassName = classnames(
    styles.radio,
    styles[props.className],
    props.className,
    { [styles.disabled]: props.disabled },
    { [styles.custom]: props.customIcon },
  );
  const forId = props.name + '_' + props.value;

  return (
    <label className={labelClassName} htmlFor={forId}>
      <input
        type="radio"
        onChange={props.onChange}
        checked={props.checked}
        disabled={props.disabled}
        name={props.name}
        value={props.value}
        id={forId}
        onClick={props.onClick}
      />
      <i />
      {props.children &&
        <span>{props.children}</span>
      }
    </label>
  );
};

export default Radiobutton;



// WEBPACK FOOTER //
// ./src/components/shared/Radiobutton/index.js